// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"4c3353f2","145":"5b7935e0","394":"56449fea","547":"8da6f902","951":"ac225fbb"}[chunkId] + ".css";
};